module.exports = __webpack_public_path__ + "assets/661f661ff5829086c05a34cd19801801.mp4";